import { AxiosInstance } from "axios";
import getConfig from "next/config";

import serviceRequest from "api/serviceRequest";

const { publicRuntimeConfig } = getConfig();

// Initialize the service request with the app and environment
const complianceApi: AxiosInstance = serviceRequest();

// Configure and set upstream URL
complianceApi.defaults.baseURL = publicRuntimeConfig.complianceApiUrl;

export default complianceApi;
